export default "__VITE_PUBLIC_ASSET__deb53d4e__"